import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Menu = (props) => {
  return (
    <div className={ classNames('post-login-menu-component', props.className) }>
      <div className="dropdown-arrow"></div>
      { props.children }
    </div>
  );
};

Menu.propTypes = {
  className: PropTypes.string
};

export default Menu;
